import React from 'react';

class FiveZeroFour extends React.Component {
  render() {
    return (
      <div className="login-container">
        <div className="text-center login-block under-maintenance">
          <p className="line1">ページを表示できません</p>
          <p className="not-found">504 Gateway Timeout</p>
          <p className="line2">アクセスしようとしたページは表示できませんでした。<br />
            時間をおいて再度お試しください。</p>
        </div>
      </div>
    );
  }
}

export default FiveZeroFour;
